// extracted by mini-css-extract-plugin
export default {"salesBalanceBlock":"SalesBalance_salesBalanceBlock__DZZ3+"};